export const enum ImportType {
  ACTIVITY_CUSTOMER_CATALOG = "activity_customer_catalog",
  SERVICE_CUSTOMER_CATALOG = "service_customer_catalog",
  SUPPLIER_SERVICES_CATALOG = "supplier_services_catalog"
}

export interface ImportTypeSearch {
  import: ImportType
}
